import { useEffect } from 'react';
import { Colors } from '@doordash/design-language';
import PaymentStrings from '../PaymentStrings';
import { VgsFormFieldName, } from './Types/vgsCollect';
var INPUT_SUCCESS_COLOR = Colors.TextSecondary;
var INPUT_ERROR_COLOR = Colors.TextError;
var styles = {
    'font-family': 'DD-TTNorms, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    color: INPUT_SUCCESS_COLOR,
    'font-size': '16px',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
};
var useGenerateVgsFormEffect = function (props) {
    var isVgsLoaded = props.isVgsLoaded, vgsConfig = props.vgsConfig, setForm = props.setForm, setCardData = props.setCardData;
    useEffect(function () {
        if (!isVgsLoaded) {
            return;
        }
        var vgsForm = window.VGSCollect.create(vgsConfig.VAULT_ID, vgsConfig.VAULT_ENV, function (state) {
            var _a, _b, _c, _d;
            // field is interchangeably called iin / bin, web bff and payment
            // service call it iin, so to align with that, we'll use iin also
            var iin = parseInt((_b = (_a = state[VgsFormFieldName.Number]) === null || _a === void 0 ? void 0 : _a.bin) !== null && _b !== void 0 ? _b : 0, 10);
            var last4 = parseInt((_d = (_c = state[VgsFormFieldName.Number]) === null || _c === void 0 ? void 0 : _c.last4) !== null && _d !== void 0 ? _d : 0, 10);
            setCardData({ last4: last4, iin: iin });
        });
        setForm(vgsForm);
        // Configuration:
        // https://github.com/doordash/tf_cdn_cloudflare/pull/704/files
        vgsForm.useCname(vgsConfig.VAULT_CNAME);
        // NOTE: expiration date should be first field for serializers to merge form
        // details correctly.
        vgsForm.field('#cc-expiration-date', {
            type: 'card-expiration-date',
            name: VgsFormFieldName.Expiration,
            successColor: INPUT_SUCCESS_COLOR,
            errorColor: INPUT_ERROR_COLOR,
            placeholder: PaymentStrings.cardExpiryMMYY(),
            validations: ['required', 'validCardExpirationDate'],
            css: styles,
            autoComplete: 'cc-exp',
            yearLength: '2',
            serializers: [
                {
                    name: 'separate',
                    options: { monthName: 'expMonth', yearName: 'expYear' },
                },
            ],
        });
        var cardNumber = vgsForm.field('#cc-number', {
            type: 'card-number',
            name: VgsFormFieldName.Number,
            successColor: INPUT_SUCCESS_COLOR,
            errorColor: INPUT_ERROR_COLOR,
            placeholder: 'XXXX XXXX XXXX XXXX',
            showCardIcon: false,
            validations: ['required', 'validCardNumber'],
            autoComplete: 'cc-number',
            css: styles,
        });
        var cvc = vgsForm.field('#cc-cvc', {
            type: 'card-security-code',
            name: VgsFormFieldName.CVC,
            successColor: INPUT_SUCCESS_COLOR,
            errorColor: INPUT_ERROR_COLOR,
            placeholder: 'CVC',
            validations: ['required', 'validCardSecurityCode'],
            autoComplete: 'cc-csc',
            css: styles,
        });
        cardNumber.setCVCDependency(cvc);
        if (vgsConfig.ZIP_REQUIRED) {
            vgsForm.field('#cc-zip', {
                type: 'text',
                name: VgsFormFieldName.Zip,
                successColor: INPUT_SUCCESS_COLOR,
                errorColor: INPUT_ERROR_COLOR,
                placeholder: PaymentStrings.cardZipCode(),
                // dont require zip
                validations: ['postal_code/intl'],
                css: styles,
            });
        }
    }, [isVgsLoaded]); // eslint-disable-line react-hooks/exhaustive-deps
};
export default useGenerateVgsFormEffect;
